import { Routes, Route, useNavigate } from "react-router-dom";
import Layout from "../user/Layout";
import Home from "../user/Home";
import Blogs from "../user/Blogs";
import Survey from "../user/Survey";
import NoPage from "../user/NoPage";

import Register from "../user/Register"
import {Login, Logout} from "../user/LoginLogout"
// import Logout from "../user/LogoutNIU"
import ForgetPassword from "../user/forget-password";
import ResetPassword from "../user/Reset-password";
import VerifyAccount from "../user/VerifyAccount"

import ServantLayout from "../user/servant/ServantLayout";
import Dashboard from "../user/servant/Dashboard";
import Lesson from "../user/servant/Lesson";
import LessonDetails from "../user/servant/Lesson-details";
import Training from "../user/servant/Training";
import Message from "../common/Message";
import Setting from "../user/servant/Setting";

import MentorLayout from "../user/mentor/Layout";
import MentorDashboard from "../user/mentor/Dashboard";
// import MentorMessage from "../user/mentor/Message";
import MentorSetting from "../user/mentor/Setting";

import AdminLayout from "../secure/Layout"
import {AdminLogin, AdminLogout} from "../secure/LoginLogout"
import AdminDashboard from "../secure/Dashboard"
import NoAuth, {RequireAuthServant, RequireAuthMentor, RequireAuthAdmin} from "../Utils/Utils";
import Servants from "../secure/servants/Servants";
import GetServant from "../secure/servants/GetServant";
import AllAssignments from "../secure/assignmets/AllAssignments"; 
import AddAssignment from "../secure/assignmets/AddAssignment";
import EditAssignment from "../secure/assignmets/EditAssignment";
// import Mentors from "../secure/Mentors";
import ViewUploadAssignment from "../secure/assignmets/ViewUploadAssignment";
import MatchMaking from "../secure/servants/Match-Making";
import AddAttendance from "../secure/attendance/add-attendance";

import { useState, useEffect } from 'react';
import io from 'socket.io-client';
import { HTTPURL } from "../constants/matcher";
import ChatHome from "../pages/home/index";
import Chat from "../pages/chat";
import CreateSocketRoutes from "./socketRoutes";
// const socket = io.connect(HTTPURL);

const CreateRoutes = () => {
    // const [username, setUsername] = useState('');
    // const [room, setRoom] = useState('');

    // console.log("create socket connection ...")
    var socket = io.connect(HTTPURL);

    return (
        <Routes>
            <Route element={<NoAuth />}>
                <Route path="/" element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path="blogs" element={<Blogs />} />
                    <Route path="register" element={<Register />} />
                    <Route path="login" element={<Login />} />
                    <Route path="forgot-password" element={<ForgetPassword />} />
                    <Route path="/verify-account/:code" element={<VerifyAccount />} />
                    <Route path="reset-password/:token" element={<ResetPassword />} />
                </Route>

                <Route path="/secure" element={<AdminLogin />} />
            </Route>

            <Route path="/logout" element={<Logout />} />
            <Route path="/logoutAdmin" element={<AdminLogout />} />

            <Route element={<RequireAuthServant />}>
                <Route path="/civil-servant/survey" element={<Survey />} />
                
                <Route path="/civil-servant" element={<ServantLayout socket={socket} />} >
                    {CreateSocketRoutes(socket)}
                    
                    <Route index element={<Dashboard />} />
                    {/* <Route path="survey" element={<Survey />} /> */}
                    <Route path="lessons" element={<Lesson />} />
                    <Route path="lesson-details/:id" element={<LessonDetails />} />
                    <Route path="training" element={<Training />} />
                    <Route path="settings" element={<Setting />} />
                </Route>
            </Route>

            <Route element={<RequireAuthMentor />}>
                <Route path="/mentor/survey" element={<Survey />} />

                <Route path="/mentor" element={<ServantLayout  socket={socket}/>} >
                    {CreateSocketRoutes(socket)}
                    
                    <Route index element={<MentorDashboard />} />
                    {/* <Route path="survey" element={<Survey />} /> */}
                    <Route path="settings" element={<MentorSetting />} />
                </Route>
            </Route>
            
            <Route element={<RequireAuthAdmin />}>
                <Route path="/secure" element={<AdminLayout socket={socket} />} >
                    {CreateSocketRoutes(socket)}
                    
                    <Route path="dashboard" element={<AdminDashboard />} />
                    <Route path="civil-servants">
                        <Route path="" element={<Servants />} />
                        <Route path="view/:user_id" element={<GetServant />} />
                    </Route>
                    
                    <Route path="mentors">
                        <Route path="" element={<Servants />} />
                        <Route path="view/:user_id" element={<GetServant />} />
                        <Route path="match-making/:user_id" element={<MatchMaking />} />
                    </Route>

                    <Route path="assignments">
                        <Route path="" element={<AllAssignments />} />
                        <Route path="add-assignment" element={<AddAssignment />} />
                        <Route path="edit-assignment/:assignment_id" element={<EditAssignment />} />
                        <Route path="view-upload-assignments/:assignment_id" element={<ViewUploadAssignment />} />
                    </Route>    

                    <Route path="attendance">
                        <Route path="add-attendance" element={<AddAttendance />} />
                    </Route>                    
                </Route>
            </Route>

            <Route path="*" element={<NoPage />} />
        </Routes>
    );
};

export default CreateRoutes;

// export default createRoutes;
